/*** IMPORTS FROM imports-loader ***/
var define = false;

var document = require('./_global').document;
module.exports = document && document.documentElement;

